import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Attribute } from '../../models/attributes/attribute';
import { AppConfigService } from '../../services/app-config.service';
import { AWSService } from '../../services/aws.service';
import { PersonDetailsService } from '../../services/person-details.service';
import { PersonProfileService } from 'src/app/people/profile/person-profile.service';
import { Router } from '@angular/router';
import { Subscription } from '@datadog/browser-core';
import { TeamService } from '../../services/team.service';

@Component({
  selector: 'app-custom-document-viewer',
  templateUrl: './custom-document-viewer.component.html',
  styleUrls: ['./custom-document-viewer.component.scss'],
})
export class CustomDocumentViewerComponent implements OnInit, OnDestroy {
  @Input() documentAttribute: Attribute;
  @Input() entityType: string;

  constructor(
    private awsService: AWSService,
    private appConfigService: AppConfigService,
    private personDetailsService: PersonDetailsService,
    private profileService: PersonProfileService,
    private teamService: TeamService,
    private router: Router
  ) {}

  private entityId: string = '';
  private subscription: Subscription;
  public fileNames: Array<string>;

  ngOnInit(): void {
    this.fileNames = this.documentAttribute.value.split('|').map((e) => e.trim());

    if (this.isInProfileMode) {
      this.subscription = this.profileService.person.subscribe((person) => {
        if (person) {
          this.entityId = person.id;
        }
      });
    } else if (this.isInTeamsMode) {
      this.subscription = this.teamService.team.subscribe((team) => {
        if (team) {
          this.entityId = team.id;
        }
      });
    } else {
      this.entityId = this.personDetailsService.currentPerson.id;
    }
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  openCustomDocument(fileName: string) {
    let documentKey = this.getdocumentKey(fileName);

    if (this.isInTeamsMode) {
      this.awsService.getTeamObjectUrl(this.entityId, documentKey).subscribe((result) => {
        if (result) window.open(result.url, '_blank');
      });
    } else {
      this.awsService.getUserObjectUrl(this.entityId, documentKey).subscribe((result) => {
        if (result) window.open(result.url, '_blank');
      });
    }
  }

  private get isInProfileMode(): boolean {
    return this.router.url.includes('/profile');
  }

  private get isInTeamsMode(): boolean {
    return this.entityType == 'Team';
  }

  private getdocumentKey(fileName: string): string {
    let tenantId = this.appConfigService.tenant.id;
    return `${tenantId}/${this.isInTeamsMode ? 'team-documents' : 'person-documents'}/${
      this.entityId
    }/${this.documentAttribute.attributeDefinitionId}/${fileName}`;
  }
}
